/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { EquipmentAttachmentService } from './EquipmentAttachmentService';

class EquipmentAttachmentServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new EquipmentAttachmentService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { EquipmentAttachmentServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/service/EquipmentAttachmentServiceProvider.js